const SkeletonLoader = () => {
  const getRandomWidth = () => {
    return Math.floor(Math.random() * 30) + 60;
  };

  return (
    <div className="w-full animate-pulse">
      {Array.from({ length: 6 }, (_, i) => (
        <div
          key={i}
          className="h-5 bg-gray-200 rounded mb-4"
          style={{ width: `${getRandomWidth()}%` }}
        ></div>
      ))}
    </div>
  );
};

export default SkeletonLoader;
